(() => {
  const observedHeadings = new WeakSet();
  let frame;

  const positionAccents = () => {
    frame = null;
    document.querySelectorAll('.th-hero h1').forEach((heading) => {
      const text = heading.querySelector('.th-heading-text');
      const accents = heading.querySelector('.th-spark');
      const firstStroke = accents?.querySelector('.th-spark-stroke-first');
      if (!text || !firstStroke) return;
      const range = document.createRange();
      range.selectNodeContents(text);
      const firstLine = [...range.getClientRects()].find((rect) => rect.width > 0);
      if (!firstLine) return;
      const headingRect = heading.getBoundingClientRect();
      const accentRect = accents.getBoundingClientRect();
      const strokeOffset = firstStroke.getBoundingClientRect().left - accentRect.left;
      const gap = parseFloat(getComputedStyle(heading).getPropertyValue('--th-accent-gap'));
      heading.style.setProperty('--th-accent-x', `${firstLine.right - headingRect.left + gap - strokeOffset}px`);
    });
  };

  const schedulePosition = () => {
    if (frame == null) frame = requestAnimationFrame(positionAccents);
  };

  const observer = new ResizeObserver(schedulePosition);
  const initialize = () => {
    document.querySelectorAll('.th-hero h1').forEach((heading) => {
      if (observedHeadings.has(heading)) return;
      observedHeadings.add(heading);
      observer.observe(heading);
    });
    positionAccents();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
  window.addEventListener('resize', schedulePosition);
  document.fonts.ready.then(schedulePosition);
  document.fonts.addEventListener('loadingdone', schedulePosition);
})();
